// type 11
const CollectPermissions = {
    Applications: false,
    BoostaApplications: false,
    Payments: false,
    Collect: true,
    Collections: true,
    ActiveAccounts: false,
    WeddingApplications:false,
    BalanceStatement: false,
    Sales: false,
    Statement: false,
    CollectionApi: false,
    CreateCollectionApplication: false,
    OnlinePayments: false,
    actions: true,
}

export default CollectPermissions